export default "__VITE_ASSET__JzBOsKiT__"